import type { FC } from "react";
import React from "react";
import { Body, Box, Link } from "@edreamsodigeo/prisma-design-system";

import styles from "../../LightboxBenefitsDesktop/AccordionItemDesktop/styles";

interface BenefitsWithTermsAndConditionsLinkProps {
  description: string;
  termsAndConditions: string;
  termsAndConditionsLink: string;
  isOpen: boolean;
}

const BenefitsWithTermsAndConditionsLink: FC<
  BenefitsWithTermsAndConditionsLinkProps
> = ({ description, termsAndConditions, termsAndConditionsLink, isOpen }) => {
  return (
    <Box
      style={{
        ...styles.description,
        transition: isOpen
          ? "max-height 300ms ease-out"
          : "max-height 150ms ease-out",
        maxHeight: isOpen ? "100%" : "0",
        whiteSpace: "pre-line",
      }}
    >
      <Body type={"xSmall"} weight={"normal"} color={"neutral.70"}>
        {description}
      </Body>
      {termsAndConditions && termsAndConditionsLink && (
        <Box mt={"base"}>
          <Link
            target={"_blank"}
            href={termsAndConditionsLink}
            variant={"legal"}
            size={"small"}
          >
            <Body type={"xSmall"} weight={"normal"} color={"neutral.70"}>
              {termsAndConditions}
            </Body>
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default BenefitsWithTermsAndConditionsLink;
